import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import {useStyles} from './helpers';

const DialogSuccess = ({openModal, setOpenModal, label}) => {
    const classes = useStyles();

    return (
        <Dialog onClose={() => setOpenModal(false)} open={openModal}>
            <div className={classes.wrapDialog}>
                <h3 className={classes.titleDialog}>{label ? label : 'Бонус сохранен'}</h3>
                <span className={classes.dialogButton}
                    onClick={() => setOpenModal(false)}
                >
                    ОК
                </span>
            </div>
        </Dialog>
    )
}

export default DialogSuccess;